import { useState } from "react";
import axios from "axios";
import { BellRing, CalendarClock, CalendarPlus, MapPin, Navigation, Pencil, Phone, Trash2 } from "lucide-react";
import { API } from "../lib/apiClient";
import { Modal } from "./common";
import { WaTemplateButton } from "./WaTemplatePicker";
import { RESULTS, RESULT_COLORS, dayTitle, fullAddr, googleCalUrl, mapsUrl, sortAppts } from "../lib/appt";

function CalendarButtons({ appt, addr }) {
  const token = localStorage.getItem("sigortapro-token") || "";
  return (
    <div className="appt-cal-actions">
      <a className="outline-button" href={`${API}/appointments/${appt.id}.ics?token=${encodeURIComponent(token)}`} data-testid="appt-add-calendar"><CalendarPlus size={14} /> Telefon takvimine ekle</a>
      <a className="outline-button" href={googleCalUrl(appt, addr)} target="_blank" rel="noreferrer" data-testid="appt-add-google-calendar">Google Takvim</a>
    </div>
  );
}

export function AppointmentDetail({ appt, all, person, onEdit, onUpdated, onDeleted, onClose }) {
  const [busy, setBusy] = useState(false);
  const addr = fullAddr(person);
  const history = sortAppts(all.filter((a) => a.customerId && a.customerId === appt.customerId)).reverse();
  const testReminder = async () => {
    try { const { data } = await axios.post(`${API}/appointments/test-reminder`, { appointmentId: appt.id }); window.alert(`Deneme hatırlatması ${data.delivered} cihaza gönderildi.`); }
    catch (e) { window.alert(e?.response?.data?.detail || "Gönderilemedi"); }
  };
  const setResult = async (result) => {
    setBusy(true);
    try { const { data } = await axios.put(`${API}/appointments/${appt.id}`, { ...appt, result }); onUpdated(data); }
    catch (e) { window.alert(e?.response?.data?.detail || "Kaydedilemedi"); } finally { setBusy(false); }
  };
  const remove = async () => {
    if (!window.confirm("Bu randevu çöp kutusuna taşınsın mı? (30 gün içinde geri yükleyebilirsiniz)")) return;
    const { data } = await axios.delete(`${API}/appointments/${appt.id}`);
    onDeleted(appt.id, data?.trashId);
  };
  return (
    <Modal title={appt.customerName} onClose={onClose}>
      <div className="appt-detail" data-testid="appointment-detail">
        <div className="appt-detail-top">
          <span className="appt-phone" data-testid="appt-detail-phone">{appt.phone || "Telefon yok"}</span>
          {person?.kind === "lead" && <span className="badge badge-amber">Potansiyel aday</span>}
        </div>
        <div className="appt-detail-actions">
          <WaTemplateButton appt={appt} className="whatsapp-button" label="WhatsApp mesaj" testId="appt-detail-wa" />
          {appt.phone && <a className="primary-button small" href={`tel:${appt.phone}`} data-testid="appt-detail-call"><Phone size={14} /> Ara</a>}
        </div>
        <CalendarButtons appt={appt} addr={addr} />
        <button type="button" className="text-button appt-test-reminder" onClick={testReminder} data-testid="appt-test-reminder"><BellRing size={14} /> Bu randevu için hatırlatma testi gönder</button>
        <dl className="appt-detail-grid">
          <div><dt><CalendarClock size={13} /> Tarih · saat</dt><dd data-testid="appt-detail-when">{dayTitle(appt.date)} · {appt.time}</dd></div>
          <div><dt>Görüşme şekli</dt><dd>{appt.mode}</dd></div>
          <div className="wide"><dt>Konu</dt><dd>{appt.subject || "—"}</dd></div>
          {appt.note && <div className="wide"><dt>Not</dt><dd className="pre">{appt.note}</dd></div>}
          {addr && (
            <div className="wide"><dt><MapPin size={13} /> Adres</dt><dd data-testid="appt-detail-address">{addr}</dd>
              <a className="outline-button appt-nav" href={mapsUrl(addr)} target="_blank" rel="noreferrer" data-testid="appt-detail-directions"><Navigation size={14} /> Yol tarifi (Google Haritalar)</a></div>
          )}
        </dl>
        <label className="field full">
          <span>Görüşme sonucu</span>
          <select value={appt.result || ""} disabled={busy} onChange={(e) => setResult(e.target.value)} data-testid="appt-result-select">
            <option value="">Sonuç seçin</option>
            {RESULTS.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </label>
        {history.length > 0 && (
          <div className="appt-history" data-testid="appt-history">
            <h4>Görüşme geçmişi</h4>
            <ul>
              {history.map((h) => (
                <li key={h.id} className={h.id === appt.id ? "current" : ""}>
                  <b>{dayTitle(h.date)} · {h.time}</b>
                  <span>{h.subject || "Randevu"} · {h.mode}{h.result && <em className={`badge badge-${RESULT_COLORS[h.result]}`}>{h.result}</em>}</span>
                  {h.note && <p>{h.note}</p>}
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className="modal-actions">
          <button type="button" className="outline-button danger" onClick={remove} data-testid="appt-delete-button"><Trash2 size={14} /> Sil</button>
          <button type="button" className="primary-button" onClick={onEdit} data-testid="appt-edit-button"><Pencil size={14} /> Düzenle</button>
        </div>
      </div>
    </Modal>
  );
}
